import { useEffect } from 'react';
import { useWorkspace } from '@/contexts/WorkspaceContext';

export const useBrand = () => {
  const { brand, currentWorkspace } = useWorkspace();

  useEffect(() => {
    const root = document.documentElement;
    
    // Apply brand colors if they exist
    if (brand.primary) {
      root.style.setProperty('--primary', brand.primary);
    }
    
    if (brand.accent) {
      root.style.setProperty('--accent', brand.accent);
    }

    // Update favicon if brand specifies one
    if (brand.favicon_url) {
      const favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
      if (favicon) {
        favicon.href = brand.favicon_url;
      } else {
        const newFavicon = document.createElement('link');
        newFavicon.rel = 'icon';
        newFavicon.href = brand.favicon_url;
        document.head.appendChild(newFavicon);
      }
    }

    // Update page title to include workspace name
    if (currentWorkspace?.name) {
      document.title = `${currentWorkspace.name} - BillPortal`;
    } else {
      document.title = 'BillPortal';
    }

    // Cleanup function to reset to defaults when component unmounts
    return () => {
      if (!brand.primary) {
        root.style.removeProperty('--primary');
      }
      if (!brand.accent) {
        root.style.removeProperty('--accent');
      }
    };
  }, [brand, currentWorkspace]);

  return brand;
};